import { render, staticRenderFns } from "./chillFilter.vue?vue&type=template&id=4ca6d033"
import script from "./chillFilter.vue?vue&type=script&lang=js"
export * from "./chillFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports